import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTVenueDanceHistory from "../page/VTVenueDanceHistory";

export default function LandingVenueDanceHistory({page}) {
    return (
        <>
            <Header headerType="AdminDancePayOnly"/>
            <VTVenueDanceHistory/>
            <Footer/>
        </>
    );
}